import React from "react";
import { useTranslation } from "react-i18next";
import { Caption1 } from "@activecollab/components";
import classnames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import useAcSelectDate from "~/components/Hooks/useAcSelectDate.jsx";
import { BodyItem } from "./BodyItem.jsx";
import { FormatLocalDateTime } from "../../../../Formatters/FormatLocalDateTime.jsx";
import { FormatLocalTime } from "../../../../Formatters/FormatLocalTime.jsx";

export const DateSeparator = ({ timestamp, className }) => {
  const { t } = useTranslation();
  const { today } = useAcSelectDate();

  const yesterday = today.clone().subtract(1, "day");

  return (
    <BodyItem className={classnames("tw-justify-center", className)}>
      <Caption1
        weight="bold"
        color="tertiary"
        className="tw-py-3"
      >
        {today.format("YYYY-MM-DD") === moment.unix(timestamp).format("YYYY-MM-DD") ? (
          <span>
            {t("Today")} <FormatLocalTime value={timestamp} />
          </span>
        ) : yesterday.format("YYYY-MM-DD") === moment.unix(timestamp).format("YYYY-MM-DD") ? (
          <span>
            {t("Yesterday")} <FormatLocalTime value={timestamp} />
          </span>
        ) : (
          <FormatLocalDateTime value={timestamp} />
        )}
      </Caption1>
    </BodyItem>
  );
};

DateSeparator.propTypes = {
  timestamp: PropTypes.number.isRequired,
  className: PropTypes.string,
};
